import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import "./i18n";
import { motion } from "framer-motion";

// Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Advantages from "./components/Advantages";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AdminContacts from "./components/AdminContacts";

// Main Page Component
const MainPage = () => {
  return (
    <motion.div 
      className="App"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Advantages />
        <Contact />
      </main>
      <Footer />
    </motion.div>
  );
};

function App() {
  useEffect(() => {
    // Smooth scrolling for the entire page
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/admin/contacts" element={<AdminContacts />} />
      </Routes>
    </Router>
  );
}

export default App;